//Core
import React, { Component } from "react"

import { classes } from "../../../helpers/classname"

//styles
import style from "./style.module.scss"

export default class Main extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, true)
  }

  handleScroll = event => {
    event.target.documentElement.scrollTop < 10
      ? this.props.closeHeader()
      : this.props.openHeader()
  }

  render() {
    const { children, hideHeader } = this.props
    return (
      <main className={classes(style.Main, hideHeader ? "" : style.hide)}>
        {children}
      </main>
    )
  }
}
